import {
    LIST_LICENCES,
    LIST_LICENCES_SUCCESS,
    LIST_LICENCES_ERROR,
    ADD_LICENCES,
    SAVE_LICENCES,
    SAVE_LICENCES_SUCCESS,
    SAVE_LICENCES_ERROR,
    DELETE_LICENCES,
    DELETE_LICENCES_SUCCESS,
    DELETE_LICENCES_ERROR,
    EDIT_LICENCES,
    UPDATE_LICENCES,
    UPDATE_LICENCES_SUCCESS,
    UPDATE_LICENCES_ERROR
} from '../types';

import clienteAxios from '../config/axios';
import authToken from '../config/token';

import { ErrorMessage, SuccessMessage, WaitingMessage } from '../components/extras/toastMessages';
import { MSG_CREATE_SUCCESS, MSG_UPDATE_SUCCESS, MSG_DELETING, MSG_DELETE_SUCCESS } from '../constants/messages';
import Swal from 'sweetalert2';
import { METHOD_DISABLED } from '../constants/requestMethods';

const controller = 'licencia';

//LISTAR LICENCES
export function listLicencesAction(params) {
    return async (dispatch) => {
        //Inicializo
        dispatch( listLicences() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.get(`/${controller}`, { params });
            //Obtengo los datos
            const licences = response.data;
            //const licences = licencesData;
            //Llamo al dispatch
            dispatch( listLicencesSuccess(licences) );
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( listLicencesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const listLicences = () => ({
    type: LIST_LICENCES,
    payload: true
});

const listLicencesSuccess = licences => ({
    type: LIST_LICENCES_SUCCESS,
    payload: licences
});

const listLicencesError = error => ({
    type: LIST_LICENCES_ERROR,
    payload: error
});

//ADD AUDIENCE CATEGORY
export function addLicencesAction(showForm) {
    return (dispatch) => {
        //Inicializo
        dispatch( addLicences(false) );
        //Abro el formulario
        showForm();
    }
}

const addLicences = isEdit => ({
    type: ADD_LICENCES,
    payload: isEdit
});

//SAVE AUDIENCE CATEGORY
export function saveLicencesAction(licence, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( saveLicences() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.post(`/${controller}`, licence);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( saveLicencesSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_CREATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( saveLicencesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const saveLicences = () => ({
    type: SAVE_LICENCES,
    payload: true
});


const saveLicencesSuccess = licence => ({
    type: SAVE_LICENCES_SUCCESS,
    payload: licence
});

const saveLicencesError = error => ({
    type: SAVE_LICENCES_ERROR,
    payload: error
});

//EDIT AUDIENCE CATEGORY
export function editLicencesAction(licence, showForm) {
    return async (dispatch) => {
        //Inicializo
        dispatch( editLicences(licence) );
        //Abro el formulario
        showForm();
    }
}

const editLicences = licence => ({
    type: EDIT_LICENCES,
    payload: licence
});

//UPDATE AUDIENCE CATEGORY
export function updateLicencesAction(licence, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( updateLicences() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.put(`/${controller}/${licence.id}`, licence);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( updateLicencesSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_UPDATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( updateLicencesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const updateLicences = () => ({
    type: UPDATE_LICENCES,
    payload: true
});

const updateLicencesSuccess = licence => ({
    type: UPDATE_LICENCES_SUCCESS,
    payload: licence
});

const updateLicencesError = error => ({
    type: UPDATE_LICENCES_ERROR,
    payload: error
});

//DELETE AUDIENCE CATEGORY
export function deleteLicencesAction(licence) {
    return async (dispatch) => {
        //Inicializo
        dispatch( deleteLicences() );
        //Mensaje de Espera
        WaitingMessage(MSG_DELETING);
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            // const response = await clienteAxios.delete(`/${controller}/${licence.id}`);
            const response = await clienteAxios.put(`/${controller}/${licence.id}/${METHOD_DISABLED}`);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( deleteLicencesSuccess(response.data) );
            //Oculto espera
            Swal.close();
            //Mensaje
            SuccessMessage(MSG_DELETE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( deleteLicencesError(data) );
            //Oculto espera
            Swal.close();
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const deleteLicences = () => ({
    type: DELETE_LICENCES,
    payload: true
});

const deleteLicencesSuccess = licence => ({
    type: DELETE_LICENCES_SUCCESS,
    payload: licence
});

const deleteLicencesError = error => ({
    type: DELETE_LICENCES_ERROR,
    payload: error
});